import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import useAppContext from 'flow/hooks/useAppContext';
import { View } from './types';

interface Props {
    view: View;
    onSetView: (view: View) => void;
    onCopy: () => void;
    showSummaryToggle?: boolean;
}

const TranscriptionToolbar = ({
    view,
    onSetView,
    onCopy,
    showSummaryToggle = true,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="flex gap-3 border-t border-gray-200 pt-4">
            <IconButton
                onClick={onCopy}
                tooltipLabel="Copy"
                className="size-8 rounded bg-gray-200"
            >
                <Icon iconKey="copyOutlined" size="1.5rem" />
            </IconButton>
            {showSummaryToggle && (
                <IconButton
                    onClick={() =>
                        onSetView(view === 'summary' ? 'transcript' : 'summary')
                    }
                    tooltipLabel={i18next.t('ai.summary.summary')}
                    className="size-8 rounded bg-gray-200"
                >
                    <Icon iconKey="formatListBulleted" size="1.5rem" />
                </IconButton>
            )}
        </div>
    );
};

export default TranscriptionToolbar;
